import { OnboardingDetailsLocalStorageRepository } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/entities/OnboardingDetailsLocalStorageRepository';
import { OnboardingDetailsRepository } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/entities/OnboardingDetailsRepository';

export class OnboardingDetailsRepositoryFactory {
  public static getRepository(): OnboardingDetailsRepository {
    return new OnboardingDetailsLocalStorageRepository();
  }
}
